import InitialCard from "../../../common/InitialCard";
import styles from "./index.module.css";
import Locations from "./cart/locations";
import CategoryList from "./search-category";
import { closeIcon } from "../../../../assets";

const StoreSideMenu = ({
  organisation,
  accessPoints,
  accessPointId,
  categories,
  activeCategory,
  activeSubCategory,
  onClose,
  onSwitchCategory,
  onSwitchSubCategory,
  onLocationChange,
}) => {
  return (
    <div className={styles.menuCase}>
      <div className={styles.menuTop}>
        <div className={styles.menuLogo}>
          <InitialCard image={organisation.logoUrl} name={organisation.orgName} />
          <div className={styles.handleCard}>
            <div className={styles.handleName}>{organisation.orgName}</div>
            <div className={styles.storeFront}>
              {organisation.settings.storeName || "StoreFront"}
            </div>
          </div>
        </div>

        <span className={styles.closeButton} onClick={onClose}>
          {closeIcon}
        </span>
      </div>

      {accessPoints && accessPoints.length > 1 && (
        <div className={styles.menuLocationName}>
          <h3>
            Store Location:{" "}
            <span>
              {accessPoints.find((point) => point.accessPointId === accessPointId)
                ?.name || "Unknown Location"}
            </span>
          </h3>
        </div>
      )}

      <div className={styles.menuInfoCase}>
        {categories && categories.length > 0 && (
          <div className={styles.menuCategories}>
            <CategoryList
              categories={categories}
              activeCategory={activeCategory}
              activeSubCategory={activeSubCategory}
              handleCategoryChange={onSwitchCategory}
              handleSubCategoryChange={onSwitchSubCategory}
            />
          </div>
        )}
        <Locations
          locations={accessPoints}
          accessPointId={accessPointId}
          handleLocationChange={onLocationChange}
          className={styles.menuLocation}
          dropdownThemeKey="storeDrawerLocation"
        />
      </div>
    </div>
  );
};

export default StoreSideMenu;
